import React from 'react';
import Link from 'gatsby-link';
import { Container } from 'react-responsive-grid';

import { rhythm, scale } from '../utils/typography';
import Footer from '../components/Footer';

import '../css/common.css';

class Template extends React.Component {
  render() {
    const { location, children } = this.props;
    let header;

    const isIndexPath = (pathname) => {
      let rootPath = `/`;
      if (typeof __PREFIX_PATHS__ !== `undefined` && __PREFIX_PATHS__) {
        rootPath = __PATH_PREFIX__ + `/`;
      }
      return pathname === rootPath || pathname.includes('posts');
    };

    if (isIndexPath(location.pathname)) {
      header = (
        <h1
          style={{
            marginBottom: rhythm(1),
            marginTop: 0
          }}
        >
          <Link
            style={{
              boxShadow: 'none',
              textDecoration: 'none',
              color: 'inherit'
            }}
            to={'/'}
          >
            Unfinished Thoughts
          </Link>
        </h1>
      );
    } else if (location.pathname.startsWith(`/tags/`)) {
      header = (
        <div>
        <h1
          style={{
            marginBottom: rhythm(1),
            marginTop: 0
          }}
        >
          <Link
            style={{
              boxShadow: 'none',
              textDecoration: 'none',
              color: 'inherit'
            }}
            to={'/'}
          >
            Unfinished Thoughts
          </Link>
        </h1>
        <h4
        style={{
          marginTop: 0,
          marginBottom: rhythm(-1)
        }}
      >
        <Link style={{ boxShadow: 'none' }} to={'/'}>
          Home
        </Link>
      </h4>
      </div>
      );
    } else {
      header = (
        <h4
          style={{
            marginTop: 0,
            marginBottom: rhythm(-1)
          }}
        >
          <Link style={{ boxShadow: 'none' }} to={'/'}>
            Home
          </Link>
        </h4>
      );
    }
    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
        }}
        >
        <Container
          style={{
            maxWidth: rhythm(24),
            padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
            flex: '1 0 auto',
            width: '100%',
          }}
        >
          {header}
          {children()}
        </Container>
        <Footer />
      </div>
    );
  }
}

Template.propTypes = {
  children: React.PropTypes.func,
  location: React.PropTypes.object,
  route: React.PropTypes.object
};

export default Template;



// WEBPACK FOOTER //
// ./src/layouts/index.js